import { TwoFactorSmsSetup } from "@/components/Portal/UserAccount/Security/Change/TwoFactorSmsSetup";

export const TwoFactorSetupSmsView = () => (
  <div className="max-w-[560px]">
    <TwoFactorSmsSetup />
  </div>
);
